<template>
    <gofix-card title="All Cases" fullContent classContent="mb-0 p-0 cases-dashboard">
        <gofix-default-table :settings="tableConfig" 
            :table-items="tableItems" 
            :tbody-tr-class="rowClass" 
            @load-items="getTableData" 
            @row-click="detailItem" 
            ref="gofixTable">
            <template slot="gofix_table:actions" slot-scope="row">
                {{''}}
            </template>
            <template slot="gofix_table:reported_time" slot-scope="row">
                {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:repeated_feedback" slot-scope="row">
                {{(row.item.repeated_feedback && row.item.repeated_feedback.length) ? (row.item.repeated_feedback.length - 1) : 0}}
            </template>
            <template slot="gofix_table:order_number" slot-scope="row">
                <span class="checklistLink" @click="gotoOrderNumber(row.item)"> {{ row.item.order_number }} </span>
            </template>
        </gofix-default-table>
    </gofix-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
export default {
    name: 'case-management',
    props: {
        status: {
            type: String,
            default: null
        },
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['case_management']));
        return {
            tableConfig: {
                name: 'case-management',
                controls: {
                    create:false,
                    delete: false,
                    reload: false,
                    tableFilter: false,
                    tablePagination: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            modals: {
                order: {
                    open: false,
                    loading: false,
                    data: {
                        supplier: null,
                        supplier_id: null,
                        officer_in_charge_id: null,
                    }
                }
            }
        }
    },
    watch: {
        "currentRoles": function(val, old) {
            this.tableConfig.controls = {
                create:false,
                delete: false,
                reload: false,
                tableFilter: false,
                tablePagination: false,
                tableImport: false,
                tableExport: false,
                tableColumnSettings: false,
            }
        },
        status: function() {
            if(this.$refs.gofixTable) this.$refs.gofixTable.reloadTableKeepFilter();
        },
        ClientContractID: function(val, old) {
            if((val && old || !val) && this.$refs.gofixTable)
                this.$refs.gofixTable.reloadTableKeepFilter();
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
            currentRoles: 'AuthController/roles',
        })
    },
    created() {},
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            tableRequest.filter.status.value = this.status;
            await this.$store.dispatch("CaseManagementController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the case management", "danger");
                    reject();
                })
        },
        async detailItem(item, event) {
            if (event.target.children[0] && event.target.children[0].className.includes("checklistLink")) {
                if (item.work_order_id) {
                    this.$router.push(`/v2/orders/${item.work_order_id}`);
                }
                return;
            }
            return this.$router.push({
                name: 'case-detail',
                params: {
                    id: item.id
                }
            })
        },
        gotoOrderNumber(item) {
            if (item.work_order_id) {
                this.$router.push(`/v2/orders/${item.work_order_id}`);
            }
        },
        /*----------------------------------------*/
        rowClass(item, type) {
            if (item) {
                if (item.status === "Open") {
                    return 'row-case-new';
                }
            }
            return null;
        }
    }
}
</script>